import type {
  TTrajectorySelectedReferenceTree,
  TTrajectorySelectedReferenceWellbore,
} from '../types/selected-reference-data';

import type { TrajectoryPlanOrFact } from './model';

export type TWellboreTrajectoryRequest = {
  wellboreId: number;
  trajectoryIds: number[];
};

type CollectParams = {
  planOrFact: TrajectoryPlanOrFact | null;
  selectedWellboreId: number | null;
  selectedReferenceData: TTrajectorySelectedReferenceTree;
};

function collectFactWellbore(
  wellbore: TTrajectorySelectedReferenceWellbore,
  add: (wellboreId: number, trajectoryId: number) => void,
): void {
  for (const trajectory of wellbore.trajectories) {
    add(wellbore.wellboreId, trajectory.trajectoryId);
  }
}

/** Builds unique wellbore -> trajectoryIds requests for fact-only loading. */
export function collectFactTrajectoryRequests({
  planOrFact,
  selectedWellboreId,
  selectedReferenceData,
}: CollectParams): TWellboreTrajectoryRequest[] {
  if (planOrFact === 'plan') {
    return [];
  }

  const byWellbore = new Map<number, Set<number>>();

  const add = (wellboreId: number, trajectoryId: number) => {
    const existing = byWellbore.get(wellboreId) ?? new Set<number>();
    existing.add(trajectoryId);
    byWellbore.set(wellboreId, existing);
  };

  if (planOrFact === 'fact' && selectedWellboreId != null) {
    if (!byWellbore.has(selectedWellboreId)) {
      byWellbore.set(selectedWellboreId, new Set());
    }
  }

  for (const well of selectedReferenceData.wells) {
    for (const wellbore of well.fact ?? []) {
      collectFactWellbore(wellbore, add);
    }
  }

  return [...byWellbore.entries()].map(([wellboreId, trajectoryIds]) => ({
    wellboreId,
    trajectoryIds: [...trajectoryIds],
  }));
}
